import React, { useRef, useEffect } from 'react';

const MedicineSearch = ({
  medicines,
  loading,
  error,
  searchText,
  setSearchText,
  showDropdown,
  setShowDropdown,
  onMedicineSelect,
  onEnterPress,
  hasSearched
}) => {
  const medicineInputRef = useRef(null);
  const medicineDropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        medicineInputRef.current &&
        medicineDropdownRef.current &&
        !medicineInputRef.current.contains(event.target) &&
        !medicineDropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowDropdown]);

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Search Medicines <span className="text-red-500">*</span>
      </label>
      <div className="relative" ref={medicineInputRef}>
        <input
          type="text"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            // Don't show dropdown while typing - only after search is executed
            setShowDropdown(false);
          }}
          onKeyDown={(e) => {
            // Trigger search immediately when Enter is pressed
            if (e.key === 'Enter' && onEnterPress) {
              e.preventDefault();
              onEnterPress();
            }
          }}
          onFocus={() => {
            // Only show dropdown if search has been executed and there are results
            if (hasSearched && searchText.trim().length > 0 && medicines.length > 0) {
              setShowDropdown(true);
            }
          }}
          placeholder={loading ? 'Loading medicines...' : 'Search medicines...'}
          disabled={loading}
          className={`w-full px-4 py-2.5 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
            loading ? 'bg-gray-100 cursor-not-allowed border-gray-300' : 'border-gray-300'
          }`}
        />
        {showDropdown && hasSearched && searchText.trim().length > 0 && medicines.length > 0 && (
          <div
            ref={medicineDropdownRef}
            className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto"
          >
            {medicines.map((medicine) => (
              <div
                key={medicine.id}
                onClick={() => onMedicineSelect(medicine)}
                className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors flex items-center justify-between"
              >
                <span>
                  {medicine.name}
                  {medicine.pack_size && (
                    <span className="block text-xs text-gray-600">{medicine.pack_size}</span>
                  )}
                </span>
                <span className="text-sm text-gray-500">₹{(medicine.price || medicine.mrp || 0).toFixed(2)}</span>
              </div>
            ))}
          </div>
        )}
        {showDropdown && hasSearched && searchText.trim().length > 0 && medicines.length === 0 && !loading && (
          <div
            ref={medicineDropdownRef}
            className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg p-4 text-center text-gray-500"
          >
            No medicines found
          </div>
        )}
        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}
      </div>
    </div>
  );
};

export default MedicineSearch;

